import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { AutocompleteResult } from 'SearchApp/ts/interfaces/autocomplete-result.interface';
import { SearchAllResult } from 'SearchApp/ts/interfaces/search-all.interface';

import { AjaxService } from 'Angular/services/core/ajax.service';
import { UrlsService } from 'Angular/services/core/urls.service';

@Injectable({
    providedIn: 'root',
})
export class SearchService {
    constructor(private ajaxService: AjaxService, private urlsService: UrlsService) {}

    getSuggestDataListResults(
        searchType: string,
        queryParams: Record<string, any>,
        defaultOnly?: boolean
    ): Observable<AutocompleteResult[]> {
        const urlParams = { searchType };
        const getParams: any = { ...queryParams };
        if (defaultOnly) {
            getParams.defaultOnly = defaultOnly;
        }
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SUGGEST, urlParams);
        return this.ajaxService.getDataObserveBody<AutocompleteResult[]>(requestUrl, getParams);
    }

    getSearchAllResults(
        searchType: string,
        queryInput: string,
        pageNum: number,
        perPage: number = 50
    ): Observable<SearchAllResult> {
        const urlParams = { searchType, queryInput, pageNum, perPage };
        const requestUrl = this.urlsService.getUrl(this.urlsService.SEARCH.SEARCH_ALL_DATA);
        return this.ajaxService.getDataObserveBody<SearchAllResult>(requestUrl, urlParams);
    }
}
